"use strict";

(() => {
	class IM_Stories_Carousel_Widget {
		/** @type {HTMLElement} */
		#$widget;

		/** @type {Swiper} */
		#photos_swiper;

		/** @type {Swiper} */
		#contents_swiper;


		constructor($widget) {
			this.#$widget = $widget;
		}

		initialize() {
			// Photos carousel.
			const $photos_carousel = this.#$widget.querySelector( '.swiper.im-sc-photos-carousel' );
			const $photos_prev     = $photos_carousel.querySelector( '.elementor-swiper-button-prev' );
			const $photos_next     = $photos_carousel.querySelector( '.elementor-swiper-button-next' );

			this.#photos_swiper = new Swiper( $photos_carousel, {
				slidesPerView: 1,
				spaceBetween: 32,
				loop: true,
				loopAdditionalSlides: 3,
				centeredSlides: true,
				allowTouchMove: false,
				speed: 500,
				navigation: {
					nextEl: $photos_next,
					prevEl: $photos_prev,
				},
				autoplay: {
					delay: 5000,
					disableOnInteraction: true,
				},
				breakpoints: {
					576: {
						slidesPerView: 3,
					}
				}
			} );

			// Contents carousel.
			const $contents_carousel = this.#$widget.querySelector( '.swiper.im-sc-contents-carousel' );

			this.#contents_swiper = new Swiper( $contents_carousel, {
				slidesPerView: 1,
				spaceBetween: 0,
				loop: true,
				loopAdditionalSlides: 3,
				centeredSlides: true,
				allowTouchMove: false,
				speed: 500,
				effect: 'fade',
			} );

			// Synchronize slides.
			this.#photos_swiper.on( 'slideChange', () => {
				this.#contents_swiper.slideToLoop( this.#photos_swiper.realIndex );
			} );
		}
	}

	// Initialize widgets.
	const $widgets = document.querySelectorAll( '.im-stories-carousel' );

	for ( const $widget of $widgets ) {
		$widget.storiesCarouselWidget = new IM_Stories_Carousel_Widget( $widget );
		$widget.storiesCarouselWidget.initialize();
	}
})();
